/**
 * No-effect placeholder function.
 */
export var NO_OP = function NO_OP() {};